import { CloseIcon } from 'components/icons'
import Logo from 'components/layout/logo'
import Footer from 'components/onboarding/footer'
import Lines from 'components/onboarding/lines'
import { Tooltip } from 'components/ui'
import { useOnboarding } from 'context/onboarding-context'
import classNames from 'helpers/class-names'
import { FC, Fragment, ReactNode } from 'react'
import { Transition } from '@headlessui/react'

interface Props {
  children: ReactNode
  isVisible: boolean
}

const Wrapper: FC<Props> = ({ children, isVisible }) => {
  const { close, isForward } = useOnboarding()

  return (
    <dialog
      aria-modal="true"
      role="dialog"
      className={classNames(
        'absolute left-0 top-0 flex h-screen w-screen flex-row items-center justify-center bg-transparent px-6 font-body font-semibold tracking-normal antialiased sm:px-20 xl:px-40',
        { 'pointer-events-none': !isVisible },
      )}>
      <Transition
        show={isVisible}
        as={Fragment}
        enter="transform transition duration-300 ease-in-out"
        enterFrom={classNames('opacity-0', {
          'translate-x-full': isForward,
          '-translate-x-full': !isForward,
        })}
        enterTo="opacity-100 translate-x-0"
        leave="transform duration-300 transition ease-in-out"
        leaveFrom="opacity-100 translate-x-0"
        leaveTo={classNames('opacity-0', {
          '-translate-x-full': isForward,
          'translate-x-full': !isForward,
        })}>
        <div className="flex w-full max-w-6xl flex-col gap-3 rounded-2xl bg-white shadow-lg xl:min-w-[1152px]">
          <div className="flex flex-col">
            <button
              className="m-4 self-end rounded-lg text-gray-200 outline-none transition duration-300 ease-in-out hover:bg-gray-50 hover:text-gray-300 focus-visible:ring-2 focus-visible:ring-info/75 active:scale-90"
              onClick={close}>
              <Tooltip tip="Close">
                <CloseIcon className="size-6 md:size-10" />
              </Tooltip>
            </button>
          </div>
          <div className="flex w-full flex-col px-6 pb-0 pt-4 md:px-24">
            <Logo className="w-56 pb-10 text-gray sm:w-72 md:w-80" />
            {children}
            <Footer />
          </div>
          <Lines className="w-44" />
        </div>
      </Transition>
    </dialog>
  )
}

export default Wrapper
